// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__FFUg5","heading":"LearnWin_heading__GxXOK","subheading":"LearnWin_subheading__mZ30F","grid":"LearnWin_grid__Xq2YO","card":"LearnWin_card__MRVh0"};